import { scaleLinear, scaleThreshold } from "d3-scale";
import chroma from "chroma-js";

const scales = {
  scaleLinear: scaleLinear,
  scaleThreshold: scaleThreshold,
};

export default class ColorScales {
  constructor({ main, opts }) {
    this._ = main;
    this.createColorScales(opts.colorScales);
    this.config = opts.colorScales;
  }

  isCategoryScale(variable) {
    return (
      this.config[variable] &&
      this.config[variable].needsUpdate !== undefined &&
      this.config[variable].needsUpdate === true
    );
  }

  getColorScale(key) {
    return this[key];
  }

  createCategoryScales(variable, config) {
    const alpha = 1;
    const { palettes } = config;

    const output = {};
    let lightColor = "#ffffff";
    const paletteLength = config.domain.length;
    const baseScale = scales[config.scaleType]().domain(config.domain);

    for (let index = 0; index < palettes.length; index++) {
      const [partyName, color] = palettes[index];

      const baseColor = chroma(color.trim());
      const palette = createPalette(baseColor, paletteLength);

      const scale = baseScale.copy().range(palette);
      output[partyName] = scale;
    }

    // add default gray scale
    const paletteGray = createPalette("#444", paletteLength);
    const scale = baseScale.range(paletteGray);
    output["otros"] = scale;

    return output;

    // creates a colour ramp from white to the given colour and removes the first two to avoid too light colours
    function createPalette(color, paletteLength) {
      return chroma
        .bezier([lightColor, color])
        .scale()
        .mode("lab")
        .correctLightness()
        .colors(paletteLength + 2) // it will 9 colors
        .map((color) => chroma(color).alpha(alpha).hex())
        .slice(1, paletteLength + 2);
    }
  }

  createColorScales(opts) {
    Object.entries(opts).forEach(([variable, content]) => {
      if (scales[content.scaleType]) {
        if (content.needsUpdate === true) {
          this[variable] = this.createCategoryScales(variable, content);
        } else {
          this[variable] = scales[content.scaleType]()
            .domain(content.domain)
            .range(content.palettes);
        }
      } else {
        console.error(
          `Scale type ${content.scaleType} is not loaded by default in EPMapboxMap.`
        );
      }
    }, this);
  }
}
